import isNil from 'ramda/src/isNil';
import { transformCartItemInstanceProperties } from './instance.property.helper';
import { BILLING_EFFECTIVE_DATE_INTENTION } from '../constants/wizard.constants';
export var buildSubmitOrderRequestData = function buildSubmitOrderRequestData(shoppingCart, paymentInstrumentIds, paymentInstruments) {
  var recordPaymentInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var redemptionCodes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var discretionaryDiscounts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var discretionaryDiscountReasonCode = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var executionOptions = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
  var shippingAddressId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var shippingMethodId = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
  var shipToName = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
  var offeringId = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
  var orderTaxLocation = arguments.length > 12 ? arguments[12] : undefined;
  var useDefaults = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : true;
  var additionalProperties = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : null;
  var orderDetails = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : {};
  var requestData = {
    AdditionalProperties: additionalProperties,
    DiscretionaryDiscounts: discretionaryDiscounts,
    OfferingId: offeringId,
    RedemptionCodes: redemptionCodes,
    ShoppingCart: transformCartItemInstanceProperties(shoppingCart, executionOptions),
    UseDefaults: useDefaults
  };
  if (recordPaymentInfo) {
    requestData.PaymentInstrumentIds = paymentInstrumentIds;
  } else {
    requestData.RecordPaymentInformation = recordPaymentInfo;
    requestData.PaymentInstruments = [paymentInstruments];
  }
  if (orderDetails !== null && orderDetails !== void 0 && orderDetails.comment) {
    requestData.OrderComment = orderDetails.comment;
  }
  if (orderDetails !== null && orderDetails !== void 0 && orderDetails.reasonCode) {
    requestData.ReasonCode = orderDetails.reasonCode;
  }
  if (executionOptions !== null && executionOptions !== void 0 && executionOptions.effective) {
    requestData.ExecutionDate = executionOptions.effective === BILLING_EFFECTIVE_DATE_INTENTION.OnSpecificDate ? executionOptions.specifiedDate : null;
    requestData.ExecutionDateIntention = executionOptions.effective;
  }
  var parsedDiscretionaryDiscountReasonCode = isNil(discretionaryDiscountReasonCode) ? null : Number(discretionaryDiscountReasonCode);
  if (parsedDiscretionaryDiscountReasonCode) {
    requestData.DiscretionaryDiscountReasonCode = parsedDiscretionaryDiscountReasonCode;
  }
  if (shippingAddressId) {
    requestData.ShippingAddressId = shippingAddressId;
    requestData.ShippingMethodId = shippingMethodId;
    requestData.ShipToName = shipToName;
  }
  if (orderTaxLocation) {
    requestData.OrderTaxLocation = orderTaxLocation;
  }
  return requestData;
};
export var buildSubmitRestoreOrderRequestData = function buildSubmitRestoreOrderRequestData(subscriptionId, paymentInstrumentIds, paymentInstruments) {
  var recordPaymentInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var redemptionCodes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var discretionaryDiscounts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var discretionaryDiscountReasonCode = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var shippingAddressId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var shippingMethodId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var shipToName = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
  var waiveFee = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
  var waiveFeeReason = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
  var waiveLateFee = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : false;
  var waiveLateFeeReason = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : null;
  var requestData = {
    DiscretionaryDiscounts: discretionaryDiscounts,
    RedemptionCodes: redemptionCodes,
    SubscriptionId: subscriptionId
  };
  if (recordPaymentInfo) {
    requestData.PaymentInstrumentIds = paymentInstrumentIds;
  } else {
    requestData.RecordPaymentInformation = recordPaymentInfo;
    requestData.PaymentInstruments = [paymentInstruments];
  }
  var parsedDiscretionaryDiscountReasonCode = isNil(discretionaryDiscountReasonCode) ? null : Number(discretionaryDiscountReasonCode);
  if (parsedDiscretionaryDiscountReasonCode) {
    requestData.DiscretionaryDiscountReasonCode = parsedDiscretionaryDiscountReasonCode;
  }
  if (shippingAddressId) {
    requestData.ShippingAddressId = shippingAddressId;
    requestData.ShippingMethodId = shippingMethodId;
    requestData.ShipToName = shipToName;
  }
  if (waiveFee) {
    requestData.WaiveFee = waiveFee;
    var parsedWaiveFeeReason = isNil(waiveFeeReason) ? null : Number(waiveFeeReason);
    if (parsedWaiveFeeReason) {
      requestData.WaiveFeeReason = parsedWaiveFeeReason;
    }
  }
  if (waiveLateFee) {
    requestData.WaiveLateFee = waiveLateFee;
    var parsedWaiveLateFeeReason = isNil(waiveLateFeeReason) ? null : Number(waiveLateFeeReason);
    if (parsedWaiveLateFeeReason) {
      requestData.WaiveLateFeeReason = parsedWaiveLateFeeReason;
    }
  }
  return requestData;
};
export var buildSubmitGiftOrderRequestData = function buildSubmitGiftOrderRequestData(shoppingCart, paymentInstrumentIds, paymentInstruments) {
  var recordPaymentInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var giftOrderInfo = arguments.length > 4 ? arguments[4] : undefined;
  var redemptionCodes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var discretionaryDiscounts = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var discretionaryDiscountReasonCode = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var giftOrderExecutionDate = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var shippingAddressId = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
  var shippingMethodId = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
  var shipToName = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
  var additionalProperties = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
  var requestData = buildSubmitOrderRequestData(shoppingCart, paymentInstrumentIds, paymentInstruments, recordPaymentInfo, redemptionCodes, discretionaryDiscounts, discretionaryDiscountReasonCode, giftOrderExecutionDate, shippingAddressId, shippingMethodId, shipToName);
  if (giftOrderInfo.giftMessage) {
    requestData.SenderMessage = giftOrderInfo.giftMessage;
  }
  if (giftOrderInfo.notificationDate) {
    requestData.NotificationDate = giftOrderInfo.notificationDate;
  }
  requestData.AdditionalProperties = additionalProperties;
  requestData.RecipientEmail = giftOrderInfo.recipientEmail;
  requestData.RecipientName = giftOrderInfo.recipientName;
  requestData.SendNotification = true;
  return requestData;
};